import React from 'react';
import { Navbar } from '../components/Navbar';
import './AboutPage.css';

// Placeholder founder details; fill in role and bio for each person. `image` is optional and falls back to the initial.
const founders = [
    {
        name: "Kanooli",
        image: "/img/founders/kanooli.png",
        role: "Co-founder",
        bio: "Bio coming soon."
    },
    {
        name: "Poclam",
        image: "/img/founders/poclam.png",
        role: "Co-founder",
        bio: "Bio coming soon."
    }
];

export class AboutPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        }

    }

    componentDidMount() {

    }

    render() {
        return (
            <>
                <Navbar history={this.props.history}></Navbar>
                <div className="about-page">
                    <div className="about-page-header">
                        <h1>About</h1>
                    </div>
                    <div className="about-page-content">
                        <p>
                            Clomp is an online gaming platform that allows you to play and compete with other players.
                        </p>
                    </div>

                    <section className="about-founders">
                        <h2>Founders</h2>
                        <div className="about-founders-grid">
                            {founders.map((founder) => (
                                <div className="about-founder" key={founder.name}>
                                    <div className="about-founder-avatar" aria-hidden="true">
                                        {founder.image ?
                                            <img src={founder.image} alt="" />
                                            :
                                            founder.name.charAt(0)
                                        }
                                    </div>
                                    <div>
                                        <h3>{founder.name}</h3>
                                        <p className="about-founder-role">{founder.role}</p>
                                        <p className="about-founder-bio">{founder.bio}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>
                </div>
            </>
        );
    }
}
